import * as THREE from 'three';
import store from '../store';
import Gravity from '../../utils/Gravity';
class Fountain {
    fountains = [];
    gravitys = [];
    requestId = 0;
    name = 'fountains';
    material;
    constructor() {
        setTimeout(() => {
            // 等store初始化完成后再添加事件
            store.on('pq', this.update.bind(this));
            store.on('pq-set-material', this.setMaterial.bind(this));
        });
        this.material = new THREE.PointsMaterial({
            size: 0.2,
            // size: 2 * Math.random() + 1,
            transparent: true,
            opacity: 0.8,
            depthWrite: false,
            map: null,
            // blending: THREE.AdditiveBlending,
            sizeAttenuation: true,
            // color: 0x3590e5,
            color: 0xffffff,
        });
        const animate = () => {
            this.fountains.forEach((e) => {
                if (e.moveFn) {
                    e.moveFn();
                }
            });
            this.requestId = requestAnimationFrame(animate);
        };
        animate();
    }
    setMaterial(cb) {
        cb(this.material);
    }
    dispose() {
        window.cancelAnimationFrame(this.requestId);
        this.fountains.forEach((e) => {
            e.geometry.dispose();
            store.scene?.remove(e);
        });
        this.material.dispose();
    }
    update(positions) {
        // 清除掉之前的points重新生成
        this.fountains.forEach((e) => {
            e.geometry.dispose();
            store.scene?.remove(e);
        });
        this.fountains = [];
        const group = {};
        positions.forEach((e) => {
            const arr = e.name.split('-');
            if (group[arr[0]]) {
                const positionArr = group[arr[0]];
                positionArr.push({
                    name: arr[1],
                    position: e.position,
                });
                return;
            }
            group[arr[0]] = [];
        });
        for (const key in group) {
            const arr = group[key];
            const index = arr.findIndex((e) => e.name.toLowerCase().startsWith('zhongxin'));
            if (index > -1) {
                const item = arr.splice(index, 1)[0];
                arr.forEach((e) => {
                    e.center = item.position;
                });
            }
        }
        this.reset(Object.values(group).flat());
        // const allPosition = Object.values(group)
        //   .flat()
        // this.reset(allPosition);
    }
    reset(positionsInfo, count = 300, r = 0.4) {
        const positions = positionsInfo.map((e) => e.position);
        // 喷泉命名 PQ1-Zhongxin001、PQ1-Gao001、PQ1-Di001; PQ1指定哪一个喷泉，其他分别是中心点、喷泉的高低
        if (!positions.length)
            return;
        const realCount = positionsInfo.reduce((a, b) => {
            // 高的水柱是低水柱数量的的两倍
            const num = b.name.toLowerCase().startsWith('gao') ? count * 2 : count;
            return a + num;
        }, 0);
        const geom = new THREE.BufferGeometry();
        const material = this.material;
        // 把所有位置的粒子统一成一个instansedMesh
        const position = new Float32Array(3 * realCount);
        const primaryPosition = [];
        const speedArr = [];
        const gather = 1.5; // 聚集程度
        let positionIndex = 0;
        positionsInfo.forEach((e, index) => {
            // const speedX = e.name.toLowerCase().startsWith('gao') ? (Math.random() - 0.5) * 5 : Math.random() - 0.5;
            // const speedZ = e.name.toLowerCase().startsWith('gao') ? (Math.random() - 0.5) * 5 : Math.random() - 0.5;
            let vector3 = new THREE.Vector3(Math.random(), 0, Math.random());
            if (e.center) {
                const vec3 = new THREE.Vector3(e.center.x - e.position.x, 0, e.center.z - e.position.z);
                vector3 = vec3.normalize();
            }
            const rate = 0.5;
            const speedX = rate * vector3.x;
            const speedZ = rate * vector3.z;
            const power = e.name.toLowerCase().startsWith('gao') ? 15 : 10;
            const num = e.name.toLowerCase().startsWith('gao') ? count * 2 : count;
            for (let i = 0; i < num; i++) {
                const randomX = r * Math.sin(Math.PI * Math.random()) - r / 2 + e.position.x;
                const randomY = Math.random() + e.position.y;
                // const randomY = Math.random() * Gravity.getHeightBySpeed(power) + e.position.y;
                const randomZ = r * Math.sin(Math.PI * Math.random()) - r / 2 + e.position.z;
                position[positionIndex++] = randomX;
                position[positionIndex++] = randomY;
                position[positionIndex++] = randomZ;
                const pos = new THREE.Vector3(randomX, randomY, randomZ);
                primaryPosition.push({ ...pos });
                const speed = new THREE.Vector3(speedX + (Math.random() - 0.5) / gather, power + (Math.random() * power) / gather / 8, speedZ + (Math.random() - 0.5) / gather);
                const gravity = new Gravity({ position: pos, speed });
                this.gravitys.push(gravity);
                speedArr.push(speed);
            }
        });
        geom.setAttribute('position', new THREE.BufferAttribute(position, 3));
        const particles = new THREE.Points(geom, material);
        this.fountains.push(particles);
        store.scene?.add(particles);
        let upCount = 0;
        const showTime = Gravity.getShowTime(15);
        particles.moveFn = () => {
            if (!store.isSmooth || !store.scene?.getObjectByName('mergedMesh'))
                return;
            const position = particles.geometry.attributes.position;
            if (upCount < count * 2) {
                upCount += count / 30 / showTime;
            }
            // 更新数据
            const time = Date.now();
            if (time - store.preRenderTime > 100) {
                // 如果有卡顿，重新更新每个粒子的时刻，便于计算下次位置
                this.gravitys.forEach((e) => {
                    e.time = time;
                });
                // upCount = 0;
                return;
            }
            positionIndex = 0;
            positionsInfo.forEach((e, index) => {
                const num = e.name.toLowerCase().startsWith('gao') ? count * 2 : count;
                for (let i = 0; i < num; i++) {
                    const gravity = this.gravitys[positionIndex];
                    if (i < upCount) {
                        gravity.update(time);
                        if (gravity.position.y < 0) {
                            const power = e.name.toLowerCase().startsWith('gao') ? 15 : 10;
                            gravity.reset({
                                position: new THREE.Vector3(primaryPosition[positionIndex].x, gravity.position.y, primaryPosition[positionIndex].z),
                                speed: new THREE.Vector3(gravity.speed.x, power + (Math.random() * power) / gather / 8, gravity.speed.z),
                            });
                        }
                        position.array[positionIndex * 3] = gravity.position.x;
                        position.array[positionIndex * 3 + 1] = gravity.position.y;
                        position.array[positionIndex * 3 + 2] = gravity.position.z;
                    }
                    else {
                        gravity.time = time;
                    }
                    positionIndex++;
                }
            });
            position.needsUpdate = true;
        };
    }
}
export default Fountain;
